import type { ComponentType, CSSProperties } from 'react'
import type { ToolKey } from '@/types/radar'
import { SchemaAuditDetail } from './SchemaAuditDetail'
import { SourceInfluenceDetail } from './SourceInfluenceDetail'
import { PromptSovDetail } from './PromptSovDetail'
import { HallucinationCheckDetail } from './HallucinationCheckDetail'
import { AeoDashboardDetail } from './AeoDashboardDetail'
import { LlmsDashboardDetail } from './LlmsDashboardDetail'
import { AnswerDashboardDetail } from './AnswerDashboardDetail'
import { ReadinessDashboardDetail } from './ReadinessDashboardDetail'
import { CrawlDashboardDetail } from './CrawlDashboardDetail'
import { RobotsDashboardDetail } from './RobotsDashboardDetail'
import { CitationDashboardDetail } from './CitationDashboardDetail'
import { RedditDashboardDetail } from './RedditDashboardDetail'
import { BrandDisambiguationDashboardDetail } from './BrandDisambiguationDashboardDetail'

/**
 * Props a registry detail renderer receives from `ToolDetailPanel` — the same
 * context the legacy branches had. `data` stays loose (the tool's raw run
 * payload) until each tool narrows it internally on migration.
 */
export interface ToolDetailProps {
  toolKey: ToolKey
  data: Record<string, unknown>
  toolIcon: ComponentType<{ size?: number; style?: CSSProperties }>
  toolColor: string
  toolName: string
}

/**
 * toolKey → shared dashboard detail renderer.
 *
 * A registered tool renders here; everything else falls through to
 * `ToolDetailPanel`'s legacy branch (behavior unchanged). Tools are added one
 * per step as they migrate (see context/phase3-renderer-unification-plan.md).
 */
export const detailRegistry: Partial<
  Record<ToolKey, ComponentType<ToolDetailProps>>
> = {
  schemaAudit: SchemaAuditDetail,
  sourceInfluence: SourceInfluenceDetail,
  promptSov: PromptSovDetail,
  hallucinationCheck: HallucinationCheckDetail,
  aeo: AeoDashboardDetail,
  llms: LlmsDashboardDetail,
  answer: AnswerDashboardDetail,
  readiness: ReadinessDashboardDetail,
  crawl: CrawlDashboardDetail,
  robots: RobotsDashboardDetail,
  citation: CitationDashboardDetail,
  reddit: RedditDashboardDetail,
  brandDisambiguation: BrandDisambiguationDashboardDetail,
}
